import React from 'react';
import './TrustSection.css';
import { FaShieldAlt, FaTruck, FaAward, FaStar } from 'react-icons/fa';

const TrustSection = () => {
  return (
    <section className="trust-section">
      <div className="trust-container">
        
        {/* Üst Kısım: Değerlerimiz */}
        <div className="values-grid">
          <div className="value-item">
            <FaAward className="value-icon" />
            <h4>Orijinallik Garantisi</h4>
            <p>Tüm ürünlerimiz usta onaylı ve malzeme garantilidir.</p>
          </div>
          <div className="value-item">
            <FaShieldAlt className="value-icon" />
            <h4>Güvenli Mezat</h4>
            <p>Şeffaf artırma süreci ve adil fiyatlandırma politikası.</p>
          </div>
          <div className="value-item">
            <FaTruck className="value-icon" />
            <h4>Özel Paketleme</h4>
            <p>Koleksiyonluk parçalara özel, darbe emici şık sunum kutuları.</p>
          </div>
        </div>

        {/* Alt Kısım: Yorumlar (Slider tadında ama sade) */}
        <div className="testimonials-box">
          <div className="testimonial-content">
            <div className="stars">
              <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
            </div>
            <p className="quote">
              "TikTok mezatlarından aldığım ateş kehribar tek kelimeyle muazzam. 
              İşçiliği ve paketlemesi Tesbihçimen'in kalitesini belli ediyor. 
              Koleksiyonumun en nadide parçası oldu."
            </p>
            <span className="client-name">— Ahmet Yılmaz</span>
            <span className="client-title">Koleksiyoner</span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default TrustSection;